// src/Routes/PublicRoute.js
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../Utlis/auth";

const PublicRoute = ({ children }) => {
  return isAuthenticated() ? <Navigate to="/dashboard" replace /> : children;
};

export default PublicRoute;
